import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type HeaderProps = {
    className?: string;
    children?: ReactNode;
};

export const Header = ({ className, children }: HeaderProps) => {
    return (
        <div
            className={cn(
                "tw:w-full tw:py-2 tw:px-6 tw:text-muted-foreground tw:text-sm",
                className
            )}
        >
            {children}
        </div>
    );
};
